import React from 'react';
import { fmtMin } from './engine/vreme';

const ACT_CLASS = { driving: 'driving', availability: 'availability', work: 'work', 'break/rest': 'rest' };
const SATI = Array.from({ length: 25 }, (_, h) => h);

/* Odmotana traka aktivnosti (0–24 h, u prikaznom vremenu — UTC kad je poznat datum) i ispod nje prepoznate aktivnosti — operater odmah vidi
   da li prepoznato odgovara tragu pisaljke. Klik na traku postavlja početak aktivnosti. */
export default function TraceStrip({ src, segments, ulaganje, srednja, onUlaganje, pomak = 0 }) {
    const pct = (m) => `${(m / 1440) * 100}%`;
    const click = (e) => {
        if (!onUlaganje) return;
        const r = e.currentTarget.getBoundingClientRect();
        onUlaganje(Math.max(0, Math.min(1439, Math.round(((e.clientX - r.left) / r.width) * 1440))));
    };
    return (
        <div className="trace-strip">
            <div className="trace-hours" aria-hidden="true">
                {SATI.map((h) => <span key={h} style={{ left: pct(h * 60) }}>{h}</span>)}
            </div>
            <div className="trace-img" onClick={click} title={onUlaganje ? 'Klik postavlja početak aktivnosti (kada tahograf počinje da beleži na listiću)' : undefined}>
                {/* traka sa listića je u lokalnom vremenu: pomera se za pomak (dve kopije zbog prelaza preko ponoći) */}
                {src && (
                    <div className="trace-img-pomak" style={{ transform: `translateX(${(-((pomak % 1440) + 1440) % 1440 / 2880) * 100}%)` }}>
                        <img src={src} alt="Odmotana traka aktivnosti sa listića" draggable={false} />
                        <img src={src} alt="" aria-hidden="true" draggable={false} />
                    </div>
                )}
                {SATI.map((h) => <i key={h} className="trace-tick" style={{ left: pct(h * 60) }} />)}
                <i className="trace-insert" style={{ left: pct(ulaganje) }} title={`Početak aktivnosti ${fmtMin(ulaganje)}`} />
            </div>
            <div className="trace-acts" onClick={click}>
                {segments.map((s, i) => (
                    <span key={i} className={`trace-seg ${s.type ? ACT_CLASS[s.type === 'availability' ? srednja : s.type] : 'none'}`}
                        style={{ left: pct(s.start), width: pct(s.end - s.start) }} title={`${fmtMin(s.start)}–${fmtMin(s.end)}`} />
                ))}
            </div>
        </div>
    );
}
